<template>
    <div class="designs-container">
        <design-modal-button v-if="showModalButton" />
        <div class="designs">
            <design
                v-bind:identifier="design"
                v-for="design in designsValid"
                v-bind:key="design"
                v-on:selected="designSelected"
            />
        </div>
        <design-modal v-bind:designs="designsValid" />
    </div>
</template>

<style scoped>
.designs-container {
    margin: 0px 100px 0px 100px;
}

.designs {
    font-size: 0px;
    overflow-x: auto;
    overflow-y: hidden;
    text-align: center;
    white-space: nowrap;
}
</style>

<script>
export const DesignList = {
    name: "design-list",
    props: {
        designs: {
            type: String,
            default: null,
            required: true
        },
        maxDesigns: {
            type: Number,
            default: 5
        },
        showModalThreshold: {
            type: Number,
            default: 5
        }
    },
    computed: {
        designsList() {
            return JSON.parse(this.designs);
        },
        designsValid() {
            return this.maxDesigns ? this.designsList.slice(0, this.maxDesigns) : this.designsList;
        },
        showModalButton() {
            return this.designsValid.length > this.showModalThreshold;
        }
    },
    methods: {
        designSelected(design) {
            this.$bus.trigger("design_selected", design);
        }
    }
};

export default DesignList;
</script>
